module.exports = __webpack_public_path__ + "static/brasil-112c535d27697e117cf048fcf0c26e76.png";